import { createRoutine, promisifyRoutine } from 'redux-saga-routines';
import * as actionTypes from '../constants/actionTypes';

export const GENERATE_HASH_ID = 'GENERATE_HASH_ID';
export const GENERATE_COLLATERAL_HASH_ID = 'GENERATE_COLLATERAL_HASH_ID';

export const generateHashId = createRoutine(GENERATE_HASH_ID);
export const generateCollateralHashId = createRoutine(
  GENERATE_COLLATERAL_HASH_ID,
);
export const generateHashIdPromiseCreator = promisifyRoutine(generateHashId);
export const generateCollateralHashIdPromiseCreator = promisifyRoutine(
  generateCollateralHashId,
);

const initialState = {};
export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.STORE_USER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
